export default class CommonService {
	// this method check if its a valid email.
	isEmail(email: string): boolean {
		const re =
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}

	// this method check if the password has at least one letter and number
	isValidPassword(password: string): boolean {
		const letter = /[a-zA-Z]/;
		const number = /[0-9]/;
		const valid = number.test(String(password)) && letter.test(String(password));
		return valid;
	}

	replaceSpecialChars = (text = '') =>
      text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();
}

export const serviceResponse = {
    systemError: 'system error',
    actionDenied: 'action denied',
    emptyFields: 'empty fields',
    notContent: 'not content',
    invalidEmail: 'invalid email ',
    invalidPassword: 'invalid password',
    loginWrongCredential: 'login wrong crendentials',
    emailUnavailable: 'email unavailable',
    unavailable: 'unavailable',
    ok: 'OK'
}
